import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=2c30c957&"
import script from "./Loading.ts?vue&type=script&lang=ts&"
export * from "./Loading.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports